import { useQueryParams, StringParam, NumberParam, withDefault, SetQuery } from 'use-query-params';
import { QueryParamConfigMap } from 'serialize-query-params';
import {
  ReportDateRange,
  ReportEntityType,
  ReportParams,
  ReportProduct,
  ReportView
} from '../types';

const useReportQueryParams = (): [ReportParams, SetQuery<QueryParamConfigMap>] => {
  const [query, setQuery] = useQueryParams({
    entityType: withDefault(StringParam, ReportEntityType.DISTRICT),
    productFamilyCode: withDefault(StringParam, ReportProduct.KEY),
    entityId: withDefault(NumberParam, null),
    displayBy: withDefault(StringParam, null),
    dateRange: withDefault(StringParam, ReportDateRange.FOURTEEN_DAYS),
    viewAs: withDefault(StringParam, ReportView.CHART)
  });

  return [query as ReportParams, setQuery];
};

export default useReportQueryParams;
